<script>
  import {reset_url} from "./Utils/RouterUtils.svelte";
  import {normalized_video_store} from "./Utils/stores";
  import {authStore} from "./stores/authStore";
  import {active_video_store} from "./Utils/stores";
  import {playlistProgressStore} from "./stores/authStore";
  import Debug from "./Utils/Debug.svelte";
  import SingleVideoTile from "./SingleVideoTile.svelte";
  import ProgressIndicator from "./ProgressIndicator.svelte";
  import CategoryContainer from "./CategoryContainer.svelte";
  import CategoryContainerHeader from "./CategoryContainerHeader.svelte";
  import CategoryContainerBody from "./CategoryContainerBody.svelte";
  import CategorySidebar from "./CategorySidebar.svelte";
  import CategorySidebarTitle from "./CategorySidebarTitle.svelte";
  import CategorySidebarDescription from "./CategorySidebarDescription.svelte";
  import CategoryMainPanel from "./CategoryMainPanel.svelte";
  import CategoryGrid from "./CategoryGrid.svelte";

  $: activePlaylist = $active_video_store.active_playlist;
</script>

<CategoryContainer>
  <CategoryContainerHeader>
    <div class="vec-my-5">
      <div class="flex">
        <p class="vec-text-sm vec-cursor-pointer"><a on:click={reset_url}>Tutorials</a> &nbsp; &gt; &nbsp; {$active_video_store.active_playlist.title}</p>
      </div>
    </div>
  </CategoryContainerHeader>
  <CategoryContainerBody>
    <CategorySidebar>
      <CategorySidebarTitle>{activePlaylist.title}</CategorySidebarTitle>
      {#if $authStore.loggedIn}
        <div class="vec-mt-4">
          <ProgressIndicator
                  progress={$playlistProgressStore.playlistProgress[
              activePlaylist.slug.current
            ]}
          />
        </div>
      {/if}
      <CategorySidebarDescription>{$active_video_store.active_playlist.description}</CategorySidebarDescription>
    </CategorySidebar>
    <CategoryMainPanel>
      <CategoryGrid>
        {#each $active_video_store.filtered_videos as video (video._id)}
          <SingleVideoTile video={$normalized_video_store.videos[video.slug.current]}/>
        {/each}
      </CategoryGrid>
    </CategoryMainPanel>
  </CategoryContainerBody>
</CategoryContainer>
